/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useState } from 'react';
import './SearchInput.scss';
import { SearchThick, CrossCircle } from 'sushiweb/Icons';
import { grey } from 'sushiweb/tokens/color';
import { Dropdown } from '../../../UiKit';
import { orgBasedHeaderUI, orgIdKey } from '../../widgets/OrgIdDropdown/utils';

const dropDownValues = {
  order_id: 'Order ID',
  email_id: 'Email ID',
  sub_order_id: 'Suborder ID',
  user_id: 'Customer ID',
  user_number: 'Customer Phone Number',
  gr_id: 'ORD ID',
  cart_id: 'Cart ID',
  valet_id: 'Delivery Partner ID',
  valet_number: 'Delivery Partner Number',
};

export const SearchInput = forwardRef(
  (
    {
      inputVal = '',
      dropdownVal = '',
      isDropdown = true,
      isCross = false,
      onSelect = () => {},
      onChange = () => {},
      onClick = () => {},
      onKeyPress = () => {},
      clearSearch = () => {},
    },
    ref,
  ) => {
    const [currentOrg, setCurrentOrg] = useState();
    useEffect(() => {
      const currentOrgKey = sessionStorage.getItem(orgIdKey);
      setCurrentOrg(currentOrgKey);
    }, [sessionStorage.getItem(orgIdKey)]);
    const getPlaceholderText = () => {
      let placeholderText = `Enter the Order ID here...`;
      for (let [key, value] of Object.entries(dropDownValues)) {
        if (dropdownVal === key) placeholderText = `Enter the ${value} here...`;
      }
      if (['user_number'].includes(dropdownVal)) {
        placeholderText =
          'For international numbers, use country code. Ex +91...';
      }
      return placeholderText;
    };
    const getInputType = () => {
      let inputType = 'text';
      if (dropdownVal === 'user_email') {
        inputType = 'email';
      }
      return inputType;
    };

    const filterInput = (e) => {
      if (e.target.type === 'number') {
        e.key === 'e' && e.preventDefault();
      }
    };

    return (
      <div className='searchInput'>
        {!!isDropdown && (
          <>
            <div
              className='dropdown'
              css={`
                :first-child > div > div > div > div {
                  max-height: 4.4rem;
                }
              `}
            >
              <Dropdown
                isNaked={true}
                dropDownValues={dropDownValues}
                dropdownVal={dropdownVal}
                onSelect={onSelect}
              />
            </div>
            <div className='divider'>
              <span></span>
            </div>
          </>
        )}
        <div className='searchInputWrapper'>
          <input
            className={`medium ${isDropdown ? '' : 'noDropdown'}`}
            type={getInputType()}
            placeholder={getPlaceholderText()}
            value={inputVal}
            onChange={onChange}
            onKeyPress={onKeyPress}
            onKeyDown={filterInput}
            min='0'
            ref={ref}
          />
          {!!isCross && (
            <span className='crossIcon pointer' onClick={clearSearch}>
              <CrossCircle size={16} color={grey.z300} />
            </span>
          )}
        </div>
        <div
          className={`searchIcon ${
            currentOrg
              ? orgBasedHeaderUI[currentOrg]?.searchIconColor
              : 'tw-bg-green-700'
          }`}
          onClick={onClick}
        >
          <SearchThick color='white' />
        </div>
      </div>
    );
  },
);
